import Vue from "vue";

function filter(value: string, limit: number) : string {
	if (value.length <= limit) {
		return value;
	}

	return value.substring(0, limit) + "…";
}

export default {
	install() {
		Vue.filter("ellipsis", filter);
	}
};

export { filter };
